var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function helpText($compile, cmdiOptions) {
        return {
            transclude: true,
            replace: false,
            templateUrl: 'views/partials/elements/helpText.html',
            controller: function ($scope, $element, $attrs, $transclude) {
                $scope.operationName = $attrs.operationname;
                cmdiOptions.getDeveloperInformationForServiceName($scope.operationName).then(function (developerInformation) {
                    $scope.developerInformation = developerInformation;
                });
                $scope.manualCollapsed = JSON.parse(window.localStorage.getItem('basWebServices.hideServiceManual'));
                $scope.toggleManualCollapse = function () {
                    $scope.manualCollapsed = !$scope.manualCollapsed;
                    window.localStorage.setItem('basWebServices.hideServiceManual', JSON.stringify($scope.manualCollapsed));
                };
            },
        };
    }
    BASWebServices.helpText = helpText;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=helpText.js.map